import React, { useState, useEffect, useContext } from 'react'
import { Map } from './Map'
import { connect } from 'react-redux'
import { fetchNearbyVehicles } from './actions'
import { selectVehicles } from './reducer'
import _ from 'lodash'
import { GeolocationContext } from 'components/GeolocationContext'

function MapContainer(props) {
    const { position, zoomLevel,
        vehicles, fetchNearbyVehicles,
        forceFollowUser, followUser: followUserToggle } = props

    const { coords } = useContext(GeolocationContext)
    const [viewport, setViewport] = useState({ center: position, zoom: zoomLevel })
    const [followUser, setFollowUser] = useState(true)

    const fetchVehiclesThrottled = _.throttle(() => {
        fetchNearbyVehicles(viewport.center, viewport.zoom)
    }, 10000)

    const latLon = coords && [coords.latitude, coords.longitude]
    const onViewportChanged = (nviewport) => {
        // check if user changed the viewport
        if (Math.abs(viewport.center[0] - nviewport.center[0]) > 0.0001 ||
            Math.abs(viewport.center[1] - nviewport.center[1]) > 0.0001) {
            if (followUser) {
                setFollowUser(false)
            }
        }
        if (viewport !== nviewport) {
            setViewport(nviewport)
        }
        fetchVehiclesThrottled()
    }

    useEffect(() => {
        fetchVehiclesThrottled()
    }, [])

    useEffect(() => {
        if ((forceFollowUser || followUser) &&
            coords && coords.latitude && coords.longitude) {
            if (Math.abs(coords.latitude - viewport.center[0]) > 0.00001 ||
                Math.abs(coords.longitude - viewport.center[1]) > 0.00001) {
                setViewport({
                    center: [coords.latitude, coords.longitude],
                    zoom: viewport.zoom
                })
            }
        }
    }, [forceFollowUser, followUser, coords, viewport])

    useEffect(() => {
        if (followUserToggle && !followUser) {
            setFollowUser(true)
        }
    }, [followUserToggle, followUser])

    return (
        <Map
            vehicles={vehicles}
            viewport={viewport}
            userPosition={latLon}
            onViewportChanged={onViewportChanged} />
    )
}

const mapStateToProps = (state) => ({
    vehicles: selectVehicles(state)
})

const mapDispatchToProps = {
    fetchNearbyVehicles
}

export default connect(mapStateToProps, mapDispatchToProps)(MapContainer)
